import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthorizationService } from '@app/services/authorization.service';
import { LocalStorageUtilities } from '@app/utilities/local-storage-utilities';
import { PersonPortalState } from '@app/models/person-portal-state';
import { MxposTrade } from '@app/models/mxpostrade';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TransactionTypePipe } from '@app/pipes/transaction-type.pipe';
import { CommodityDescriptionPipe } from '@app/pipes/commodity-description.pipe';
import { StoplimitTypePipe } from '@app/pipes/stoplimit-type.pipe';
import { Mxstoplimit } from '@app/models/mxstoplimit';
import { MainScreenEvents } from '@app/interfaces/main-screen-events';
import { AccountValues } from '@app/models/account-values';


@Component({
  selector: 'app-account-status',
  templateUrl: './account-status.component.html',
  styleUrls: ['./account-status.component.css'],
  providers: [TransactionTypePipe, CommodityDescriptionPipe, StoplimitTypePipe]
})
export class AccountStatusComponent implements OnInit, MainScreenEvents {

  public personPortalState: PersonPortalState;
  public positions: MxposTrade[] = [];
  public stopslimits: Mxstoplimit[] = [];  

  public positionsColumns: string[] = ['tradeDate', 'tradeNum', 'unitBal', 'positionType', 'description', 'settled', 'origValue', 'extendedMktVal'];
  public stoplimitsColumns: string[] = ['expirationDate', 'tradeNum', 'orderType', 'unitBal', 'description', 'origValue'];
  public positionsDataSource = new MatTableDataSource<MxposTrade>(this.positions);
  public stoplimitsDataSource = new MatTableDataSource<Mxstoplimit>(this.stopslimits);


  @ViewChild("positionsPaginator", { static: true })
  positionsPaginator: MatPaginator;
  @ViewChild("stoplimitsPaginator", { static: true })
  stoplimitsPaginator: MatPaginator;
  @ViewChild("positionsSort", { static: true })
  positionsSort: MatSort;
  @ViewChild("stoplimitsSort", { static: true })
  stoplimitsSort: MatSort;

  constructor(
    private authorizationService: AuthorizationService,
    private changeDetectorRefs: ChangeDetectorRef) { }

  ngOnInit() {
    this.positionsDataSource.sort = this.positionsSort;
    this.stoplimitsDataSource.sort = this.stoplimitsSort;
    this.initControls();  
  }

  private initControls() {
    this.refreshUI();
    // Table paginator.
    this.positionsDataSource.paginator = this.positionsPaginator;
    this.stoplimitsDataSource.paginator = this.stoplimitsPaginator;
    // Force table to sort decendingly on tradeDate. 
    this.positionsSort.sort({ id: 'tradeDate', start: 'desc', disableClear: false });
  }

  /**
   * Called from the "Main" module when the selected account changes.
   */
  public refreshUI(): void {
     // Summary account values.
     this.refreshAccountValues();
     // Load table models.
     this.personPortalState = LocalStorageUtilities.getPersonPortalState();   
     this.positions = [];
     this.stopslimits = [];
     // Positions.
     if (this.personPortalState.mxna.mxPosTrade !== undefined) {
       this.personPortalState.mxna.mxPosTrade.forEach(mxpostrade => {
         if (mxpostrade.unitBal != 0 || mxpostrade.dolBal != 0 || mxpostrade.transferUnits != 0 || mxpostrade.pendUnits != 0) {
           this.positions.push(mxpostrade);
         }
       });
     }
     // Stops and limits.    
     if (this.personPortalState.mxna.mxstoplimit !== undefined) {
       this.personPortalState.mxna.mxstoplimit.forEach(mxstoplimit => {
         this.stopslimits.push(mxstoplimit);
       });
     }
     this.positionsDataSource.data = this.positions;
     this.stoplimitsDataSource.data = this.stopslimits;
     this.changeDetectorRefs.detectChanges();
  }

  /**
  * Refresh account's summary values.
  */
  public refreshAccountValues(): void {
    let personPortalState: PersonPortalState = LocalStorageUtilities.getPersonPortalState();    
    // TODO: Consider updating positions and limits when this is invoked.
  }

  /**
   * Used to calculate footer values.
   */
  public getTotalOrigVal(): number {
    return this.positions.filter(element => element.unitBal > 0).reduce((total, item) => total += item.dolBal, 0);
  }

  public getTotalLeasedOrigVal(): number {
    return this.positions.filter(element => element.unitBal < 0).reduce((total, item) => total += item.dolBal, 0);
  }

  public getLongMktVal(): number {
    return this.positions.filter(element => element.unitBal > 0).reduce((total, item) => total += item.extendedMktVal, 0);
  }

  public getLeasedMktVal(): number {
    return this.positions.filter(element => element.unitBal < 0).reduce((total, item) => total += item.extendedMktVal, 0);
  }

}  
